import React from 'react';

import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import WanderuErrorBoundary from 'wanderu-component-error-boundary';
import {
    fetchCarrierAction,
    carrierDataSelectors,
} from 'wanderu-ducks-carriers';
import { liveCheckItineraryAction, liveCheckSelectors } from 'wanderu-ducks-live-check';
import { tripSummarySelectors } from 'wanderu-ducks-search';
import {
    tripActions,
    tripSelectors,
    fetchTripItineraryAction,
} from 'wanderu-ducks-trips';

import SearchResultComponent from '../components/SearchResult/SearchResult';
import TripCard from '../components/TripCard/TripCard';

class SearchResult extends React.Component {
    static propTypes = {
        carrierCode: PropTypes.string.isRequired,
        carrierData: PropTypes.shape({
            businessGroup: PropTypes.string,
            carrierCode: PropTypes.string,
            features: PropTypes.arrayOf(PropTypes.string),
            liveDetails: PropTypes.bool,
            maxSeats: PropTypes.number,
            name: PropTypes.string,
            pageSlug: PropTypes.string,
            preferredCurrency: PropTypes.string,
            supplementalInfo: PropTypes.object,
            ticketDelivery: PropTypes.shape({
                eTicket: PropTypes.bool,
                idRequired: PropTypes.bool,
            }),
            vehicleType: PropTypes.string,
        }),
        carrierLoading: PropTypes.bool,
        carrierSuccess: PropTypes.bool,
        className: PropTypes.string,
        fetchCarrier: PropTypes.func,
        fetchTripItinerary: PropTypes.func,
        itinerary: PropTypes.arrayOf(PropTypes.object),
        onSelect: PropTypes.func,
        resetLiveCheckItinerary: PropTypes.func,
        seats: PropTypes.number,
        selectedFare: PropTypes.string,
        tags: PropTypes.arrayOf(PropTypes.node),
        tripDetails: PropTypes.arrayOf(PropTypes.object),
        tripId: PropTypes.string,
        tripSummary: PropTypes.bool,
        updateTrip: PropTypes.func,
        wheelchairs: PropTypes.number,
    };

    static defaultProps = {
        className: '',
        onSelect: () => null,
        tags: [],
    };

    componentDidMount() {
        const {
            carrierCode,
            carrierLoading,
            carrierSuccess,
            resetLiveCheckItinerary,
            seats = 1,
            selectedFare,
            tripId,
            tripSummary,
            updateTrip,
        } = this.props;

        if (!carrierLoading && !carrierSuccess) {
            this.props.fetchCarrier(carrierCode);
        }

        if (!tripSummary && !!selectedFare) {
            const lcParams = {
                fareVersion: 'v2',
                seats,
                selectedFare,
                tripId,
                wheelchairs: this.props.wheelchairs,
            };
            resetLiveCheckItinerary([tripId], lcParams);
            updateTrip(tripId, { selectedFare: undefined });
        }
    }

    render() {
        const {
            carrierData,
            carrierLoading,
            /* eslint-disable @typescript-eslint/no-unused-vars */
            fetchCarrier: _fetchCarrier,
            fetchTripItinerary: _fetchTripItinerary,
            /* eslint-enable @typescript-eslint/no-unused-vars */
            itinerary,
            tripDetails,
            ...otherProps
        } = this.props;

        let tripDetailsAvailable = !!itinerary;
        let carrierName;
        if (carrierData) {
            carrierName = carrierData.name;

            const {
                supplementalInfo = {},
            } = carrierData;

            tripDetailsAvailable = tripDetailsAvailable
                || supplementalInfo.itineraryinfo;
        }

        const Component = otherProps.variant === 'travelOptions'
            ? TripCard
            : SearchResultComponent;

        return (
            <WanderuErrorBoundary
                fallback=""
                scope="SearchResultContainer"
            >
                <Component
                    {...otherProps}
                    carrierBusinessGroup={carrierData?.businessGroup}
                    carrierLoading={carrierLoading}
                    carrierName={carrierName}
                    pageSlug={carrierData?.pageSlug}
                    tripDetails={tripDetails}
                    tripDetailsAvailable={tripDetailsAvailable}
                />
            </WanderuErrorBoundary>
        );
    }
}

function mapStateToProps(state, ownProps) {
    const {
        tripId,
    } = ownProps;
    const tripSet = tripSelectors.selectTripSet(state, tripId);
    const carrierCode = tripSet[0]?.carrierCode;
    const { selectedFare } = tripSelectors.selectTripData(state, tripId) || {};
    const { seats = 1, wheelchairs = 0 } = tripSummarySelectors.selectTravelerInfo(state) || {};
    const lcParams = {
        fareVersion: 'v2',
        seats,
        tripId,
        wheelchairs,
    };
    const {
        tripData: {
            selected_fare: initialSelectedFare,
        } = {},
    } = liveCheckSelectors.selectTripLiveCheck(state, lcParams) || {};

    return {
        carrierData: carrierDataSelectors.selectCarrierData(state, carrierCode),
        carrierLoading: fetchCarrierAction.selectWorking(state, carrierCode),
        carrierSuccess: fetchCarrierAction.selectSuccess(state, carrierCode),
        seats,
        selectedFare: selectedFare || initialSelectedFare,
        wheelchairs,
    };
}

const mapDispatchToProps = {
    fetchCarrier: fetchCarrierAction.fetchCarrier,
    fetchTripItinerary: fetchTripItineraryAction.fetchTripItinerary,
    resetLiveCheckItinerary: liveCheckItineraryAction.resetLiveCheckItinerary,
    updateTrip: tripActions.updateTrip,
};

export {
    SearchResult,
};
export default connect(mapStateToProps, mapDispatchToProps)(SearchResult);
